import { SVGProps } from 'react';

export function MoreVertical(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
      {...props}
    >
      <g fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="4" r="1"></circle>
        <circle cx="12" cy="12" r="1"></circle>
        <circle cx="12" cy="20" r="1"></circle>
      </g>
    </svg>
  );
}
